export enum ActionTypes {
    isLoading,
    success,
    error
}